import { User } from "./models/user";
import { create } from "zustand";
import { Notification } from "./components/Notification/Notification";

type UserStore = {
  user: User | null;
  setUser: (user: User | null) => void;
};

export const useUser = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}));

type MiscStore = {
  // This is a convenience state to check if the user has just
  // signed up as they will need to be redirected to the company details page.
  companyDetailsRequired: boolean;
  setCompanyDetailsRequired: (required: boolean) => void;
};

export const useMiscStore = create<MiscStore>((set) => ({
  companyDetailsRequired: false,
  setCompanyDetailsRequired: (required) =>
    set({ companyDetailsRequired: required }),
}));

type NotificationsStore = {
  notifications: Notification[];
  addNotification: (notification: Notification) => void;
  removeNotification: (id: string) => void;
  // TODO move to buyer frontend
  shoppingCartUpdateNotificationCount: number;
  incrementShoppingCartUpdateNotificationCount: () => void;
  clearShoppingCartUpdateNotificationCount: () => void;
};

export const useNotifications = create<NotificationsStore>((set) => ({
  notifications: [] as Notification[],
  addNotification: (notification: Notification) =>
    set((state) => ({ notifications: [notification, ...state.notifications] })),
  removeNotification: (id: string) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
  shoppingCartUpdateNotificationCount: 0,
  incrementShoppingCartUpdateNotificationCount: () =>
    set((state) => ({
      shoppingCartUpdateNotificationCount:
        state.shoppingCartUpdateNotificationCount + 1,
    })),
  clearShoppingCartUpdateNotificationCount: () =>
    set({ shoppingCartUpdateNotificationCount: 0 }),
}));
